import { BREAKPOINT_NAMES } from './constants'

export const BREAKPOINTS = {
  [BREAKPOINT_NAMES.MOBILE]: '480px',
  [BREAKPOINT_NAMES.TABLET]: '769px',
  [BREAKPOINT_NAMES.DESKTOP]: '991px',
  [BREAKPOINT_NAMES.LARGE]: '1439px',
}

const baseTheme = {
  name: 'JWC Base theme',

  breakpoints: Object.values(BREAKPOINTS),

  breakpointNames: BREAKPOINT_NAMES,

  //      0  1  2  3   4   5   6
  space: [0, 4, 8, 16, 32, 64, 128],

  //          0   1   2   3   4   5
  fontSizes: [10, 12, 16, 24, 32, 48],

  font: 'Inter, sans-serif;',
  fontTitle: 'Inter, sans-serif;',

  transitionTime: '.17s',
  borderRadius: [0, '8px', '30px'],
}

baseTheme.sizes = {
  sidebar: `${baseTheme.space[5]}px`,
  header: `60px`,
}

export default baseTheme
